import { IConfiguration } from "@/models/admin/configuration/configuration.types"
import { Status } from "@/types/Status"
import dayjs, { Dayjs } from "dayjs"

export class Configuration implements IConfiguration {
  constructor(
    public id: number,
    public name: string,
    public value: string,
    public editable: boolean,
    public fromDt: Dayjs,
    public toDt?: Dayjs,
  ) {}

  get status(): Status {
    const now = dayjs()

    if (this.toDt?.isBefore(now)) {
      return new Status("critical", "Inactive")
    }
    if (!this.toDt || this.toDt?.isAfter(now)) {
      return new Status("normal", "Active")
    }
    return new Status("default", "Undetermined")
  }
}
